"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionsConverter = void 0;
const PageableConverter_1 = require("../common/model/PageableConverter");
const convertLinks_1 = require("../common/utils/convertLinks");
const convertAttachment_1 = require("../common/utils/convertAttachment");
const VideosConverter_1 = require("../videos/model/VideosConverter");
class CollectionsConverter {
    // can throw if attachment type is not valid
    // e.g. (not a member of enum AttachmentType)
    static convert(entity) {
        const links = (0, convertLinks_1.convertLinks)(entity);
        const attachments = entity.attachments
            ? entity.attachments.map(convertAttachment_1.convertAttachment)
            : [];
        return {
            id: entity.id,
            owner: entity.owner,
            ownerName: entity.ownerName,
            title: entity.title,
            assets: CollectionsConverter.convertAssets(entity.assets),
            updatedAt: new Date(entity.updatedAt),
            discoverable: entity.discoverable,
            promotedFor: entity.promotedFor,
            mine: entity.mine,
            createdBy: entity.createdBy,
            subjects: entity.subjects,
            ageRange: entity.ageRange || null,
            description: entity.description || null,
            attachments,
            permissions: entity.permissions,
            links: { ...links, self: links.self },
        };
    }
    static convertAssets(assetEntities) {
        return assetEntities?.map((entity) => {
            return {
                id: entity.id,
                video: VideosConverter_1.VideosConverter.convert(entity.video),
                segment: entity.segment,
                note: entity.note,
                comments: this.convertComments(entity.comments || []),
            };
        });
    }
    static convertComments(comments) {
        const formatDate = (rawDate) => {
            const dateOptions = {
                month: 'long',
                day: 'numeric',
                hour12: true,
                timeZone: 'UTC',
            };
            const timeOptions = {
                hour: 'numeric',
                minute: 'numeric',
                timeZone: 'UTC',
            };
            const date = new Date(rawDate).toLocaleDateString('en-US', dateOptions);
            const time = new Date(rawDate).toLocaleTimeString('en-US', timeOptions);
            return `${date}, ${time}`;
        };
        return comments.map((comment) => {
            return {
                ...comment,
                createdAt: formatDate(comment.createdAt),
            };
        });
    }
    static convertListView(entity) {
        const links = (0, convertLinks_1.convertLinks)(entity);
        const attachments = entity.attachments
            ? entity.attachments.map(convertAttachment_1.convertAttachment)
            : [];
        return {
            id: entity.id,
            owner: entity.owner,
            ownerName: entity.ownerName,
            title: entity.title,
            assets: entity.assets.map((asset) => {
                return {
                    id: asset.id,
                };
            }),
            updatedAt: new Date(entity.updatedAt),
            discoverable: entity.discoverable,
            promotedFor: entity.promotedFor,
            mine: entity.mine,
            createdBy: entity.createdBy,
            subjects: entity.subjects,
            ageRange: entity.ageRange || null,
            description: entity.description || null,
            permissions: entity.permissions,
            attachments,
            links: { ...links, self: links.self },
        };
    }
    static convertListViewPage(entity) {
        return PageableConverter_1.PageableConverter.convert(entity, 'collections', CollectionsConverter.convertListView);
    }
    static convertPage(entity) {
        return PageableConverter_1.PageableConverter.convert(entity, 'collections', CollectionsConverter.convert);
    }
}
exports.CollectionsConverter = CollectionsConverter;
//# sourceMappingURL=CollectionsConverter.js.map